const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const JSON_HEADERS = { 'Content-Type': 'application/json' };

const handleResponse = async (response) => {
  let data = null;
  try {
    data = await response.json();
  } catch (error) {
    data = null;
  }

  if (!response.ok) {
    const message = data?.detail || data?.message || 'Unable to fetch contacts';
    throw new Error(message);
  }

  return data;
};

export const fetchContacts = async (accessToken) => {
  const response = await fetch(`${API_BASE}/contacts`, {
    method: 'GET',
    headers: {
      ...JSON_HEADERS,
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return handleResponse(response);
};

export const fetchContactById = async (accessToken, contactId) => {
  const response = await fetch(`${API_BASE}/contact/${contactId}`, {
    method: 'GET',
    headers: {
      ...JSON_HEADERS,
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return handleResponse(response);
};

export const createContact = async (accessToken, contact) => {
  const response = await fetch(`${API_BASE}/contacts`, {
    method: 'POST',
    headers: {
      ...JSON_HEADERS,
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(contact),
  });
  return handleResponse(response);
};

export const updateContactFavorite = async (accessToken, contactId, isFavorite) => {
  const response = await fetch(`${API_BASE}/contact/${contactId}`, {
    method: 'PATCH',
    headers: {
      ...JSON_HEADERS,
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({ is_favorite: isFavorite }),
  });

  return handleResponse(response);
};

export const generateContactSummary = async (accessToken, contactId, refresh = false) => {
  const response = await fetch(`${API_BASE}/contact/${contactId}/summary${refresh ? '?refresh=false' : ''}`, {
    method: 'POST',
    headers: {
      ...JSON_HEADERS,
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return handleResponse(response);
};
